<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'DatabaseConnectionList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <template v-if="isLoading">
              <Loader></Loader>
            </template>
            <template v-else>
<!--              <div class="card-header">-->
<!--                <h4 class="card-title">{{$t('views.database.create.title')}}</h4>-->
<!--              </div>-->
              <div class="card-body">
                <DatabaseConnectionForm
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations" />
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import DatabaseConnectionForm from './Form'
import Loader from '../../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('databaseconnection/create')

export default {
  components: {
    Loader,
    DatabaseConnectionForm
  },

  data () {
    return {
      item: {
        title: '',
        description: '',
        host: '',
        username: '',
        password: '',
        port: ''
      }
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'DatabaseConnectionUpdate', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let data = this.item
      data.port = parseInt(data.port)
      this.create(data)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
